export const Lang = {
  title: 'St. Andrews Links Terms and Conditions',
  textArea: {
    label: 'Terms and Conditions',
    hint: 'Edit the Terms and Conditions',
  },
  actions: {
    edit: 'Edit Terms and Conditions',
    save: 'Save the Terms and Conditions',
    cancel: 'Cancel',
  },
};
